// extracted by mini-css-extract-plugin
export var Arrow = "Arrow-module--Arrow--CjsFJ";
export var DarkArrow = "Arrow-module--DarkArrow--3Oj_E";
export var LightArrow = "Arrow-module--LightArrow--10FI3";